import EfVideo from '@elem/ui/ef-video';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useMediaDevice } from '../../hooks';

const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4918 1.1278L5.36287 12.8516C5.16366 13.1389 5.23508 13.5333 5.52239 13.7325C5.5748 13.7689 5.63241 13.7971 5.69326 13.8162L11.6082 15.6755L9.245 23.4009C9.15211 23.7045 9.32297 24.026 9.62663 24.1189C9.68114 24.1355 9.73782 24.144 9.79482 24.144H10.2406C10.4481 24.144 10.6425 24.0423 10.7608 23.8717L18.8606 12.1898C19.0598 11.9025 18.9884 11.5081 18.7011 11.3089C18.6392 11.2659 18.5701 11.2344 18.4971 11.2158L13.1625 9.85332L14.6286 1.36601C14.6696 1.12858 14.5104 0.90285 14.2729 0.861836C14.2484 0.857599 14.2236 0.855469 14.1987 0.855469L14.012 0.855469C13.8044 0.855469 13.61 0.957225 13.4918 1.1278Z"
            fill="#546AFF"
        />
    </svg>
);

export default function TheComp() {
    const { t } = useLang('Oasis.SmartBackup1');
    const { isPC, isDesktop, isH5, isPad } = useMediaDevice();
    const [enter, setEnter] = useState<boolean>(false);
    useEffect(() => {
        const info = document.querySelector('#SmartBackup1 .smart-backup-info') as HTMLDivElement;
        const scene1 = AniContainer.create({
            triggerElement: '#SmartBackup1', // 触发元素
            triggerHook: 1, // 触发时机 1 进入 0 离开
            duration: '25%',
            offset: 0,
            asyncFromTo: [[`#SmartBackup1`, { opacity: 0 }, { opacity: 1 }, 0.1]],
        });

        const scene2 = AniContainer.create({
            triggerElement: info, // 触发元素
            triggerHook: 1, // 触发时机 1 进入 0 离开
            duration: '200%',
            offset: '50%',
            onEnter: () => setEnter(true),
            onLeave: () => setEnter(false),
        });

        // 离开模块隐藏动画
        const scene3 = AniContainer.create({
            triggerElement: '#SmartBackup1',
            triggerHook: 0,
            offset: 0,
            duration: '200%',
            asyncFromTo: [[`#SmartBackup1`, { opacity: 1 }, { opacity: 0 }, 1]],
            asyncTimeLine: [1.4],
        });

        return () => {
            scene1.destroy();
            scene2.destroy();
            scene3.destroy();
        };
    }, [isPC, isDesktop, isH5, isPad]);

    // 懒加载视频
    const [loaderVideo, setLoaderVideo] = useState<boolean>(false);
    useEffect(() => {
        const loader = AniContainer.create({
            triggerElement: '#AIDriven',
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            onEnter: () => {
                setLoaderVideo(true);
            },
        });

        return () => {
            loader.destroy();
        };
    }, []);

    return (
        <div className={`${styles.TheComp}`} id="SmartBackup1">
            <div className="smart-backup-1-content">
                <div className={`smart-backup-info ${enter ? 'enter' : ''}`}>
                    <div className="smart-backup-label">
                        {icon}
                        <span>{t('label')}</span>
                    </div>
                    <div className="smart-backup-title">{t('title')}</div>
                    <div className="smart-backup-desc">
                        {t.rich('desc', {
                            h: (v: string) => <span className="smart-backup-desc-highlight">{v}</span>,
                        })}
                    </div>
                </div>
                {loaderVideo &&
                    (isPC || isDesktop ? (
                        <EfVideo
                            className="smart-backup-1-video"
                            pc="https://websiteoss.ecoflow.com/upload/video/1735527216785/SmartBackup1.mp4"
                            poster="https://websiteoss.ecoflow.com/upload/image/1735804952981/smart.jpg"
                            autoPlay
                            loop
                            preload="none"
                        />
                    ) : (
                        <EfVideo
                            className="smart-backup-1-video"
                            pc="https://websiteoss.ecoflow.com/upload/video/1735527216526/SmartBackup1-h5.mp4"
                            poster="https://websiteoss.ecoflow.com/upload/image/1735804944608/smart_M.jpg"
                            autoPlay
                            loop
                            preload="none"
                        />
                    ))}
            </div>
        </div>
    );
}
